import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  singleslot: [],
};

const slice = createSlice({
  name: 'singleslot',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET elementS
    getSingleSlot(state, action) {
      state.isLoading = false;
      state.singleslot = action.payload;
    },
  },
});
export default slice.reducer;

export function getsingleslot(id) {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/api/clinic/providers`, {
        params: {
          provider_id: id,
        },
      });
      console.log(response.data?.data, 'slots');
      dispatch(slice.actions.getSingleSlot(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
